import { useState } from 'react'
import { Modal, Button } from 'rsuite'
import useTranslation from '@/hooks/useTranslation'
import { ActionButton } from '@/components/styles'
import cn from 'classnames'

function ExternalRedirect({ externalUrl, buttonText = null }) {
  const t = useTranslation()
  const [showModal, setShowModal] = useState(false)

  const handleOpenModal = () => {
    setShowModal(true)
  }

  const handleConfirm = () => {
    setShowModal(false)
    window.open(externalUrl, '_blank', 'noopener,noreferrer')
  }

  const handleCancel = () => {
    setShowModal(false)
  }

  return (
    <>
      <div className={cn('text-center', 'mt-20')}>
        <ActionButton appearance="ghost" size="lg" onClick={handleOpenModal} aria-label={buttonText}>
          {buttonText}
        </ActionButton>
      </div>

      <Modal
        open={showModal}
        onClose={handleCancel}
        size="sm"
        role="alertdialog"
        aria-labelledby="external-redirect-title"
        aria-describedby="external-redirect-description"
      >
        <Modal.Header>
          <Modal.Title id="external-redirect-title">{t('external_redirect_title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="external-redirect-description">
            <p>{t('external_redirect_message')}</p>
            <p>
              <strong style={{ wordBreak: 'break-all' }}>{externalUrl}</strong>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleConfirm} appearance="primary" aria-label={t('external_redirect_confirm')}>
            {t('external_redirect_confirm')}
          </Button>
          <Button onClick={handleCancel} appearance="subtle" aria-label={t('external_redirect_cancel')}>
            {t('external_redirect_cancel')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ExternalRedirect
